// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.more-less-text__button_0750ad82.more-less-button_0750ad82 {
  display: inline-block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"more-less-text__button": `more-less-text__button_0750ad82`,
	"more-less-button": `more-less-button_0750ad82`
};
export default ___CSS_LOADER_EXPORT___;
